import React from 'react'
import './Footer.css'

export default function Footer () {

  return (
    <>
      <footer><a href="https://farnsworthswimschool.com/">&#169;Farnsworth Swim School 2021</a></footer>
    </>
  )
}
